import React from 'react';
import useCheckPermissions from 'hooks/auth/useCheckPermission';
import { Button, Icon } from 'components/ui';

function CreateNewProjectButton({ onClick }) {
  const { userCheckPermission } = useCheckPermissions();
  const canCreateProject = userCheckPermission('mail.projects.view');

  return (
    <Button disabled={!canCreateProject} onClick={onClick}>
      <Icon type="plus-circle" />
      &nbsp;New Project
    </Button>
  );
}

export default CreateNewProjectButton;
